// import * as React from "react"
import React, { useState } from 'react'
import { Link } from "gatsby"
import { Link as LinkScroll } from "react-scroll";
import "../styles/module.css"

let isActive = false;

const Menu = () => {
  const [active, setActive] = useState("humberger");
  const toggleMenu = () => {
    isActive=!isActive;
    setActive( isActive ? "humberger active" : "humberger" );
  }
  return (
    <div className="gnav">
      <div 
        className="humberger"
        onClick={ toggleMenu }
        className={ active }
      >
        <div>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <ul >
          <li>
            <Link className="logo" to="/">
              W
              <div>C</div>
              L
            </Link>
          </li>
          <li>
            <Link
                to="/service"
              >Service
            </Link>
          </li>
          <li>
            <Link
                to="/news"
              >News
            </Link>
          </li>
          <li>
            <Link
                to="/contact"
              >Contact
            </Link>
          </li>
          {/* <li>
            <LinkScroll
                to="/contact"
                smooth={true}
                offset={0}
                duration={500}
                onClick={ toggleMenu }
              >Contact
            </LinkScroll>
          </li> */}

          <li className="top">
            <Link className="" to="/">Top Page
            </Link>
          </li>
          
        </ul>
      </div>
    </div>
  )
}

export default Menu

